import React from 'react'
import BlogArticleBlock from './BlogArticleBlock'
import styles from './BlogArticle.module.scss'

/**
 * Canonical article surface (title + blocks).
 * Port this module to the storefront; swap --ame-article-font only.
 */
function BlogArticleView({
  title = '',
  blocks = [],
  selectedBlockId = null,
  onSelectBlock = null,
  selectable = false,
}) {
  const titleText = typeof title === 'string' ? title.trim() : ''

  return (
    <article className={styles.article}>
      {titleText ? <h1 className={styles.title}>{titleText}</h1> : null}
      <div className={styles.blocks}>
        {(Array.isArray(blocks) ? blocks : []).map((block) => {
          if (!block?.id) return null

          const isSelected = selectable && selectedBlockId === block.id
          const className = [
            styles.block,
            selectable ? styles.blockSelectable : '',
            isSelected ? styles.blockSelected : '',
          ]
            .filter(Boolean)
            .join(' ')

          if (!selectable) {
            return (
              <div key={block.id} className={styles.block} data-block-type={block.type}>
                <BlogArticleBlock block={block} />
              </div>
            )
          }

          return (
            <div
              key={block.id}
              className={className}
              data-block-type={block.type}
              role="button"
              tabIndex={0}
              onClick={() => onSelectBlock?.(block.id)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault()
                  onSelectBlock?.(block.id)
                }
              }}
            >
              <BlogArticleBlock block={block} />
            </div>
          )
        })}
      </div>
    </article>
  )
}

export default BlogArticleView
